import { Navigate, RouteObject } from 'react-router';
import { RouteConfig } from '~/routes/routeConfig';
import lazyImport from '~/utils/lazyImport';

const ReferralPage = lazyImport(() => import('~/views/referral/ReferralPage'));

export const referralRoutes: RouteObject[] = [
  {
    index: true,
    element: <ReferralPage />,
  },
  {
    path: '*',
    element: <Navigate to={RouteConfig.Referral.buildLink()} replace />,
  },
];
